import { redirect, RouterContextProvider } from 'react-router-dom';
import { auth0Client } from 'src/api/auth0_client';
import { AuthenticationService } from 'src/api/authentication_service';
import { getUserInfo, logout } from 'src/utils/auth_utils';

/**
 * Runs before every protected route. Authentication only:
 * verify session, initialize AuthenticationService, redirect to /login on failure.
 */
export const authMiddleware = async (
  { request: _request }: { request: Request; context: RouterContextProvider },
  next: () => Promise<Response>,
) => {
  try {
    const isAuthenticated = await auth0Client.isAuthenticated();

    if (!isAuthenticated) {
      await logout();
      throw redirect('/login');
    }

    const userInfo = await getUserInfo();
    AuthenticationService.initialize(userInfo);

    await next();
  } catch (error) {
    if (error instanceof Response && error.status === 302) {
      throw error;
    }

    // Token/auth error: clear session so /login doesn't redirect back to / (avoid loop)
    await auth0Client.logout();
    throw redirect('/login');
  }
};
